import ApiService from "@/utils/api.service";

export default {


    get(context, page) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("static/" + page)
                .then(({ data }) => {
                    context.commit("setPage", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    clean(context) {
        context.commit("setPage", { name: null, description: null, slug: null });
    }

}